import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { GridConfiguration } from "../../../../records/views/recordGridView";

GamingMasterAgreementGridConfigurationFactory.$inject = [
  ColumnDefinitionServiceName,
  ServerUtilityName,
  GridSettingsServiceName,
];

export function GamingMasterAgreementGridConfigurationFactory(
  columnDefinitionService: ColumnDefinitionService,
  serverUtility: ServerUtility,
  gridSettingsService: GridSettingsService
): GridConfiguration {
  return {
    gridDataSource: new RecordDataSource(
      serverUtility,
      "/api/contract/gamingContractMasterAgreement"
    ),
    gridSettings: gridSettingsService.getGridSettings(
      Symbol("contract.type.gamingMasterAgreement")
    ),
    defaultSort: "ContractNumber",
    nameSingular: "Gaming Master Agreement",
    namePlural: "Gaming Master Agreements",
    columns: [
      columnDefinitionService.getStringColDef({
        field: "ContractMachineManufacturerName",
        header: "Manufacturer",
      }),

      columnDefinitionService.getNumberColDef({
        field: "ContractNumber",
        header: "Contract Numbers",
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractStartDate",
        header: "Start Date",
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractEndDate",
        header: "End Date",
      }),
    ],
  };
}
